import { takeLatest, put, call } from 'redux-saga/effects';
import actionTypes from 'store/auth/actionTypes';
import history from 'utils/history';
import { signIn as signInAction } from 'store/auth/actions';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';

export function* signInGen(payload) {
  try {
    const res = yield call(api, {
      method: 'post',
      url: URL.SIGN_IN,
      data: {
        email: payload.payload.email,
        password: payload.payload.password,
      },
    });
    const { data } = res;
    localStorage.setItem('accessToken', data.access_token);
    localStorage.setItem('refreshToken', data.refresh_token);
    localStorage.setItem('email', payload.payload.email);
    yield put(signInAction.success({
      payload: {
        email: payload.payload.email,
        token: data,
      },
    }));
    history.push(payload.payload.pathName);
    yield call(toast.success, 'Logged in successfully');
  } catch (e) {
    yield call(toast.error, e.message);
    yield put(signInAction.error(e.message));
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.SIGN_IN, signInGen);
}
